export default [
  {
    route: "/api/brands",
    url: "https://api.jsonbin.io/b/60d8b0f7af8fbc2c76ab113a",
  },
  {
    route: "/api/products",
    url: "https://api.jsonbin.io/b/60d8b15add75532c754dc567",
  },
  {
    route: "/api/auth/login",
    url: `${process.env.REACT_APP_API}/api/user/login`,
  },
  {
    route: "/api/blog",
    url: `${process.env.REACT_APP_API}/api/blog`,
  },
  {
    route: "/api/blogs",
    url: `${process.env.REACT_APP_API}/api/blog/main_menu`,
  },
  {
    route: "/api/blog/content",
    url: `${process.env.REACT_APP_API}/api/blog/content`,
  },
];

